import styled from "styled-components";

export const EditorWrapper = styled.div`
  width: 100%;
  min-width: 720px;
  max-width: fit-content;

  max-height: 540px;
  box-sizing: border-box;
  padding: 12px 14px;
  color: #1f2937;
  background: #f8fbff;
  border: 1px solid #9cb8da;
  border-radius: 8px;
  overflow: auto;

  .attendance-editor-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
  }

  .attendance-editor-title {
    font-weight: 700;
    color: #173d68;
  }

  .attendance-editor-guide {
    margin-bottom: 8px;
    color: #4b5563;
    font-size: 12px;
  }

  .attendance-editor-grid {
    display: grid;
    grid-template-columns:
      minmax(115px, 150px) minmax(110px, 150px) minmax(170px, 1fr)
      auto;
    align-items: center;
    gap: 8px;
  }

  .attendance-editor-grid + .attendance-editor-grid {
    margin-top: 6px;
  }

  .attendance-editor-grid--deleted {
    opacity: 0.62;
    text-decoration: line-through;
  }

  select,
  textarea {
    width: 100%;
    color: #111827;
    background: #fff;
    border: 1px solid #8297b1;
    border-radius: 5px;
  }

  select {
    height: 32px;
    padding: 0 8px;
  }

  .attendance-editor-time-picker {
    width: 100%;
    height: 32px;
    border-color: #8297b1;
    border-radius: 5px;
  }

  textarea {
    min-height: 54px;
    margin-top: 8px;
    padding: 7px 9px;
    resize: vertical;
  }

  .attendance-editor-original {
    color: #5f6b7a;
    font-size: 12px;
  }

  .attendance-editor-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 9px;
  }

  .attendance-editor-actions-right {
    display: flex;
    gap: 8px;
  }

  .attendance-editor-history {
    margin-top: 9px;
    padding-top: 8px;
    border-top: 1px solid #c9d7e7;
  }

  .attendance-editor-history summary {
    cursor: pointer;
    font-weight: 700;
    color: #173d68;
  }

  .attendance-editor-history ul {
    max-height: 120px;
    margin: 6px 0 0;
    padding-left: 20px;
    overflow: auto;
  }

  .attendance-editor-history li {
    margin-bottom: 4px;
  }

  .attendance-editor-history-meta {
    margin-left: 8px;
    color: #64748b;
    font-size: 11px;
  }

  .ant-alert {
    margin: 6px 0;
    padding: 5px 10px;
  }
`;
